import { createReducer } from '@reduxjs/toolkit';

import { TransactionsHistoryStateType } from '../../types';
import {
  getTransaction,
  getTransactionHistorySearch,
  getTransactionsHistory,
  setTransactionsHistoryLoading,
} from '../actions/transactions-history';

const initialState: TransactionsHistoryStateType = {
  data: {
    history: [],
    searchHistory: [],
    pagination: {
      isFirst: true,
      isLast: false,
    },
    transaction: {},
  },
  loading: {
    transactions: false,
    getTransaction: false,
  },
};

const transactionsHistoryReducer = createReducer(initialState, (builder) => {
  builder.addCase(getTransactionsHistory.fulfilled, (state, action) => {
    if (action.payload) {
      state.data.history = action.payload;
    }
  });

  builder.addCase(getTransactionHistorySearch.fulfilled, (state, action) => {
    if (action.payload) {
      if (action.payload.first) {
        state.data.searchHistory = action.payload.content;
      } else {
        state.data.searchHistory = state.data.searchHistory.concat(
          action.payload.content
        );
      }
      state.data.pagination.isFirst = action.payload.first;
      state.data.pagination.isLast = action.payload.last;
    }
  });

  builder.addCase(setTransactionsHistoryLoading, (state, action) => {
    state.loading[action.payload.name] = action.payload.value;
  });

  builder.addCase(getTransaction.fulfilled, (state, action) => {
    state.data.transaction = action.payload;
  });
});

export default transactionsHistoryReducer;
